import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../../services/loading.service';
import { CompanyService } from '../../services/company.service';

@Component({
  selector: 'app-companies',
  templateUrl: './companies.component.html',
  styleUrl: './companies.component.scss'
})
export class CompaniesComponent implements OnInit {

  public companyData: any[] = [];
  public searchTerm: string = '';
  public statusFilter: string = '';

  // Paginación
  pageNumber: number = 1;
  pageSize: number = 20;
  totalRecords: number = 0;

  // Métricas
  totalCompanies: number = 0;
  activeCompanies: number = 0;
  inactiveCompanies: number = 0;

  // Status options for dropdown
  public statusDropdownOptions: any[] = [
    { label: 'Todos', value: '' },
    { label: 'Activo', value: 'active' },
    { label: 'Inactivo', value: 'inactive' }
  ];

  private searchTimeout: any;

  constructor(
    private _loadingService: LoadingService,
    private _companyService: CompanyService
  ) {

  }

  ngOnInit(): void {
    this.loadCompanies();
  }

  loadCompanies() {
    this._loadingService.show();
    this._companyService.getPaged(this.pageNumber, this.pageSize, this.searchTerm, this.statusFilter).subscribe({
      next: response => {
        if (response.isSuccess && response.data) {
          this.companyData = response.data.data || [];
          this.totalRecords = response.data.totalCount || 0;
          this.calculateMetrics();
        } else {
          this.companyData = [];
          this.totalRecords = 0;
        }
        this._loadingService.hide();
      },
      error: e => {
        console.log(e);
        this.companyData = [];
        this.totalRecords = 0;
        this._loadingService.hide();
      }
    });
  }

  onFilterChange(): void {
    this.pageNumber = 1;
    this.loadCompanies();
  }

  onPageChange(event: any): void {
    this.pageNumber = event.page + 1; // PrimeNG es 0-indexed
    this.pageSize = event.rows;
    this.loadCompanies();
  }

  onSearchTermChange(): void {
    // Debounce search to avoid too many API calls
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    this.searchTimeout = setTimeout(() => {
      this.onFilterChange();
    }, 500);
  }

  onStatusFilterChange(): void {
    this.onFilterChange();
  }

  clearFilters(): void {
    this.searchTerm = '';
    this.statusFilter = '';
    this.onFilterChange();
  }

  getCompanyInitials(companyName: string): string {
    if (!companyName || companyName === 'undefined' || companyName.trim() === '') return 'CO';
    const words = companyName.split(' ');
    if (words.length >= 2) {
      return `${words[0][0]}${words[1][0]}`.toUpperCase();
    }
    return companyName.substring(0, 2).toUpperCase();
  }

  /** Tono cromático determinístico para el avatar de iniciales (a-f). */
  getInitialsTone(seed: string | null | undefined): string {
    const s = (seed || '?').toUpperCase();
    const code = s.charCodeAt(0) || 0;
    const tones = ['a', 'b', 'c', 'd', 'e', 'f'];
    return tones[code % tones.length];
  }

  getRelativeTime(date: Date | string | undefined): string {
    if (!date) return '';

    const dateObj = typeof date === 'string' ? new Date(date) : date;
    const now = new Date();
    const diffInMs = now.getTime() - dateObj.getTime();
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));

    if (diffInDays > 0) {
      return `hace ${diffInDays} día${diffInDays > 1 ? 's' : ''}`;
    } else if (diffInHours > 0) {
      return `hace ${diffInHours} hora${diffInHours > 1 ? 's' : ''}`;
    } else if (diffInMinutes > 0) {
      return `hace ${diffInMinutes} minuto${diffInMinutes > 1 ? 's' : ''}`;
    } else {
      return 'hace un momento';
    }
  }

  private calculateMetrics(): void {
    this.totalCompanies = this.totalRecords;
    this.activeCompanies = this.companyData.filter(c => !c.isDeleted).length;
    this.inactiveCompanies = this.companyData.filter(c => c.isDeleted).length;
  }
}
